import { ClientIntakeFormItemsState } from './clientIntakeFormItems.firebase.state';

export class ClientIntakeFormItemsSelectors {
	static readonly _props = ClientIntakeFormItemsState._props;

	static readonly $getAllClientIntakeFormItems =
		ClientIntakeFormItemsState._props.items;
}
